import React from "react";
import { TrendingDown } from "lucide-react";
import FunnelAssessmentViewerV2Base from "./FunnelAssessmentViewerV2Base";

const FunnelMarginStabilityAssessmentViewerV2 = ({ markdown }) => (
  <FunnelAssessmentViewerV2Base
    markdown={markdown}
    title="Margin Stability & Risk"
    subtitle="Order-level profitability consistency and downside risk"
    badge="Margin"
    Icon={TrendingDown}
  />
);

export default FunnelMarginStabilityAssessmentViewerV2;
